module.exports = __webpack_public_path__ + "img/fidelidade.268f0cee.jpg";